import { useCallback, useEffect, useState } from 'react'
import { INSTITUTION_BRANDING } from 'utils/institutionBranding'

export const INSTITUTIONS = INSTITUTION_BRANDING
export const INSTITUTION_EVENT = 'chu:institution-change'

export function readInstitution() {
  try { return localStorage.getItem('institution') === 'college' ? 'college' : 'university' } catch (_) { return 'university' }
}

export function changeInstitution(value) {
  const next = value === 'college' ? 'college' : 'university'
  try { localStorage.setItem('institution', next) } catch (_) { /* optional persistence */ }
  window.dispatchEvent(new CustomEvent(INSTITUTION_EVENT, { detail: next }))
}

export default function useInstitution() {
  const [institution, update] = useState(readInstitution)
  useEffect(() => {
    const sync = () => update(readInstitution())
    const onStorage = (event) => { if (event.key === 'institution' || !event.key) sync() }
    window.addEventListener(INSTITUTION_EVENT, sync)
    window.addEventListener('storage', onStorage)
    return () => {
      window.removeEventListener(INSTITUTION_EVENT, sync)
      window.removeEventListener('storage', onStorage)
    }
  }, [])
  const setInstitution = useCallback(changeInstitution, [])
  return { institution, setInstitution, institutionInfo: INSTITUTIONS[institution] }
}
